import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EElevators } from '../../../../../../../json_query';
import { changeElevators, changeServiceLiftCheckbox } from '../../../../../../state/advanced/elevators';

import { Elevators as ElevatorsComponent } from './elevators';

export const Elevators = connect(
  (state: IAppState) => ({
    elevatorsCount: (state.filters.jsonQuery.lifts && state.filters.jsonQuery.lifts.value) || EElevators.Any,
    hasServiceLift: (state.filters.jsonQuery.lift_service && state.filters.jsonQuery.lift_service.value.gte) || false,
  }),
  (dispatch: Dispatch) => ({
    onElevatorsChanged: (value: EElevators) => {
      dispatch(changeElevators(value));
    },
    onChangedCheckbox: (value: boolean) => {
      dispatch(changeServiceLiftCheckbox(value));
    },
  }),
  // tslint:disable-next-line: no-any
)(ElevatorsComponent as any);
